/** Сидированный генератор xorshift32: состояние — одно целое, живёт в снимке мира (GAME-02). */
export function nextRandom(state: number): { value: number; state: number } {
  let x = state | 0 || 0x9e3779b9;
  x ^= x << 13;
  x ^= x >>> 17;
  x ^= x << 5;
  return { value: x >>> 0, state: x | 0 };
}

/** Целое из [0, range) и новое состояние. */
export function randomInt(state: number, range: number): { value: number; state: number } {
  const next = nextRandom(state);
  return { value: next.value % range, state: next.state };
}
